import * as zod from 'zod';

import type { DeviceInfo } from '@sb/messenger/auto_generated/messenger/skills_bot_service';

// Skill subcommand types
export const GPUTaskRunnerSkillSubCommand = zod.union([
  zod.object({
    command: zod.literal('start_inference'),
    timeout: zod.number(),
    modelName: zod.string(),
    useLearnedCompletion: zod.boolean().optional(),
    learnedCompletionThreshold: zod.number().optional(),
    learnedCompletionConsecutiveCount: zod.number().int().optional(),
    useLearnedFailure: zod.boolean().optional(),
    learnedFailureThreshold: zod.number().optional(),
    learnedFailureConsecutiveCount: zod.number().int().optional(),
  }),
  zod.object({
    command: zod.literal('stop_inference'),
  }),
  zod.object({
    command: zod.literal('configure_inference'),
    modelName: zod.string(),
    robotIdsMap: zod.record(zod.string(), zod.string()), // {[robot key]: [robot ID]}, e.g. {'robot_0': 'bot_0sapi_rvVAMObHwVGCkTkpVSY6'}
    equipmentKeyToDeviceInfo: zod.record(
      zod.string(),
      zod.custom<DeviceInfo>(),
    ),
    useGripperMask: zod.boolean().optional(),
  }),
  zod.object({
    command: zod.literal('teardown_inference'),
  }),
  zod.object({
    command: zod.literal('delete_model'),
    modelName: zod.string(),
  }),
]);

// Vision subcommand types
export const GPUTaskRunnerVisionSubCommand = zod.object({
  command: zod.literal('run_inference'),
  image: zod.string(), // base64 encoded image
  model_path: zod.string(),
  model_type: zod.string(), // Valid values: 'YoloV11', 'YoloV8-OBB', 'TextPrompt'
  thresholding_params: zod.record(zod.string(), zod.string()).optional(),
});

export const GPUTaskRunnerCommand = zod.object({
  kind: zod.literal('GPUTaskRunnerCommand'),
  equipmentId: zod.optional(zod.string()),
  commandType: zod.enum(['skill', 'vision']),
  subCommand: zod.union([
    GPUTaskRunnerSkillSubCommand,
    GPUTaskRunnerVisionSubCommand,
  ]),
});

export type GPUTaskRunnerCommand = zod.infer<typeof GPUTaskRunnerCommand>;
export type GPUTaskRunnerSkillSubCommand = zod.infer<
  typeof GPUTaskRunnerSkillSubCommand
>;
export type GPUTaskRunnerVisionSubCommand = zod.infer<
  typeof GPUTaskRunnerVisionSubCommand
>;
